import isMobile from '../../plugins/is-mobile.js';

// if (!isMobile(768) && $('.page-top').length) {
//   var videoElem = document.getElementById('topHeroVideo');
//   $('.top-hero-video-contents').get(0).play();
// }